import { ReferralIcon, ReportIcon } from "icons";

export const getMenuForNavDrawer = (type, path) => {
  return [
    {
      icon_type: <ReferralIcon />,
      title: "Referral Campaigns",
      to: path,
      path: path
    },
    {
      icon_type: <ReportIcon />,
      title: 'Reports',
      children: [{
        title: "By Property",
        to: path + '/by-property',
        path: path + '/by-property',
      }, {
        title: "Campaign Analytics",
        to: path + "/by-campaigns",
        path: path + "/by-campaigns",

      },
      {
        title: "RAF Contact List",
        to: path + "/by-contact",
        path: path + "/by-contact",
      },
      {
        title: "My Analytics",
        to: path + "/my-analytics",
        path: path + "/my-analytics",
        showBorderLine: true
      }]
    },
  ]
}
